import React from 'react'

import styled from '@emotion/styled'

import { FormBlockerElementSpacerElement } from '@cash-web/protos/squareup/franklin/form_blocker.pb'

export type SpacerElementProps = FormBlockerElementSpacerElement
const Spacer = styled.div<SpacerElementProps>`
  ${props => {
    return `height: ${props.proportion}rem;`
  }}
`
const SpacerElement = ({ proportion }: SpacerElementProps) => <Spacer proportion={proportion} />

export default SpacerElement
